<template>
  <div class="faq-container">
    <div class="div-block-2">
      <h2 class="h2c_black">{{ $t("faq.title") }}</h2>
    </div>

    <!-- 显示“常见问题”标题 -->

    <div class="faq-list">
      <div v-for="(item, index) in faqData" :key="index" class="faq-item">
        <div class="faq-question">
          <p>Q.&nbsp;&nbsp;{{ item.q }}</p>
          <!-- 显示问题 -->
        </div>
        <div class="faq-question">
          <p>A.&nbsp;&nbsp;{{ item.a }}</p>
          <!-- 显示答案 -->
        </div>
        <div class="divider" v-if="index < faqData.length - 1"></div>
        <!-- 问题之间的分隔线 -->
      </div>
    </div>
    <viewFooter></viewFooter>
  </div>
</template>

<script>
import viewFooter from '@/views/view-footer.vue'
export default {
  components: {
    viewFooter
   },
  computed: {
  faqData() {
    return this.$t('faq.questions');
  }
},
  data() {
    return {
      // faqData: this.$t('faq.questions')
    };
  }
}
</script>

<style scoped>
.faq-container {
  margin: 20px;
}
.div-block-2 {
  flex-wrap: wrap;
  justify-content: center;
  align-self: auto;
  width: auto;
  display: flex;
  transform: translate(0);
}
.h2c_black {
  border: 1px solid var(--black);
  text-align: center;
  margin-bottom: 40px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 5px 40px;
  font-family: Noto Serif TC, sans-serif;
  font-size: 44px;
  font-weight: 700;
  line-height: 70px;
  display: block;
}
.faq-list {
  border-bottom: 1px dashed #000;
  width: 940px; /* 限制宽度为940px */
  padding: 20px 50px;
  margin: auto;
}

.faq-item {
  margin-bottom: 20px;
}

.faq-question {
  margin-bottom: 5px;
  text-align: left; /* 保持左对齐 */
}

.faq-answer {
  text-align: left; /* 保持左对齐 */
  margin-bottom: 5px;
}

.divider {
  border-top: 1px dashed #ccc;
  margin-top: 10px;
}
</style>
